<template>
    <div class="manifest-editor-placeholder">
        <div class="manifest-editor-placeholder__icon">
            <feather-icon :icon="stepIcon" size="30" />
        </div>
        <h4>{{ step.title }}</h4>
        <p class="text-muted mb-1">{{ placeholderText }}</p>
        <b-badge v-if="sourceSummary" variant="light-primary">
            {{ sourceSummary.filename }} · {{ sourceSummary.tabName }} ·
            {{ sourceSummary.columnCount }} columns
        </b-badge>
    </div>
</template>

<script>
import {BBadge} from 'bootstrap-vue'

const PLACEHOLDER_TEXT = {
    review: 'The generated definition and backend validation issues will be reviewed here before a version is created.',
}

const STEP_ICONS = {
    review: 'CheckCircleIcon',
}

export default {
    components: {BBadge},
    props: {
        step: {
            type: Object,
            required: true,
        },
        sourceSummary: {
            type: Object,
            default: null,
        },
    },
    computed: {
        placeholderText() {
            return PLACEHOLDER_TEXT[this.step.id]
        },
        stepIcon() {
            return STEP_ICONS[this.step.id]
        },
    },
}
</script>

<style lang="scss" scoped>
.manifest-editor-placeholder {
    display: flex;
    min-height: 20rem;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 2rem;
    border: 1px dashed #d8d6de;
    border-radius: .357rem;
    text-align: center;
}

.manifest-editor-placeholder__icon {
    display: flex;
    width: 4rem;
    height: 4rem;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    color: var(--primary);
    background: rgba(0, 0, 0, .045);
    border-radius: 50%;
}
</style>
